export enum MemberGroup {
  Pending = 'Pending',
  Banned = 'Banned',
  Active = 'Current',
  Admin = 'Admin',
  Default = '',
}
